export function SectionBadge({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex justify-center">
      <div className="bg-bg-dark px-3 py-[5px] inline-flex items-center justify-center">
        <span className="font-jetbrains text-[18px] text-white uppercase tracking-[1.26px] text-center leading-normal">
          {children}
        </span>
      </div>
    </div>
  );
}
